import { DropDownList } from "@progress/kendo-react-dropdowns";
import React from "react";

const ContributionSourceTypeDropDown = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    }
  };

  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];

  const options = [
    {
      value: "CURRENT_INCOME",
      text: "Current Income",
    },
    {
      value: "OUTSIDE_SOURCE",
      text: "Outside Source",
    },
  ];

  if (!dataItem.inEdit) {
    const selectedOption = options.find((c) => c.value === dataValue);
    return <td>
      {selectedOption.text}
    </td>
  }

  return (
    <td>
      <DropDownList
        style={{
          width: "150px",
        }}
        onChange={handleChange}
        defaultValue={options[0]}
        value={options.find((c) => c.value === dataValue)}
        data={options}
        textField="text"
      />
    </td>
  );
};

export default ContributionSourceTypeDropDown;
